import { useMemo } from 'react';

import path from 'path';

import { Stack } from '@mui/material';
import { GridColDef, useGridApiRef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { DataGrid, useColDefs } from '~components';
import VectorImage from '~components/media/vectorImage';
import { pagePathSegments } from '~constants';
import Webhook, { webhookGridCols } from '~interfaces/webhook';
import { Dimens } from '~themes';

interface Props {
	isLoading: boolean;
	webhooks: Webhook[];
	error?: string;
}

const WebhooksDataGrid = ({ isLoading = false, webhooks, error }: Props) => {
	const persistenceKey = 'webhooks';
	const { t } = useTranslation();
	const apiRef = useGridApiRef();
	const navigate = useNavigate();

	const colDefs = useColDefs<Webhook>();
	const columns = useMemo((): GridColDef<Webhook>[] => {
		const cols = [
			colDefs.gridColDefFor(webhookGridCols.clientId),
			colDefs.gridColDefFor(webhookGridCols.scope),
			colDefs.rowActions((_value: Webhook) => [
				{
					key: 'edit-webhook',
					icon: <VectorImage name='icon/edit' />,
					label: t('edit', { ns: 'actions' }),
					onClick: () => {
						// TODO: In the future, this will have to be refactored, but it'll be with new design as well
						// We'll have to be more aware of what type of webhook we're dealing with. For the time being
						// there's only rental.
						navigate(path.join('/' + pagePathSegments.Webhooks, pagePathSegments.Rental));
					},
				},
			]),
		];
		return cols;
	}, [colDefs]);

	return (
		<Stack direction='column' sx={{ width: 1 }} gap={Dimens.spacingMd}>
			<DataGrid
				apiRef={apiRef}
				persistenceKey={persistenceKey}
				autoHeight
				disableRowSelectionOnClick
				loading={isLoading}
				columns={columns}
				rows={webhooks}
				error={(error?.length ?? 0) > 0}
				errorTitle={error}
				paginationMode='client'
			/>
		</Stack>
	);
};

export default WebhooksDataGrid;
